import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { api, formatPrice } from "../lib/api";
import Seo from "../components/Seo";

export default function Neighborhoods() {
  const [list, setList] = useState([]);

  useEffect(() => {
    api.get("/neighborhoods").then((r) => setList(r.data));
  }, []);

  return (
    <div className="bg-stone-50 min-h-screen" data-testid="neighborhoods-page">
      <Seo
        title="Houston Neighborhoods"
        description="Explore Houston's most loved residential neighborhoods — River Oaks, The Heights, Memorial, Montrose, Midtown, and West University. Neighborhood guides, median prices, and active listings."
        path="/neighborhoods"
      />
      <section className="max-w-7xl mx-auto px-6 lg:px-12 pt-20 pb-16">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-8 h-px bg-[#C9A961]" />
          <div className="eyebrow text-[#0A0A0A]">Houston · Texas</div>
        </div>
        <h1 className="font-display text-5xl lg:text-7xl leading-[0.95] tracking-tight text-[#0A0A0A] font-light max-w-3xl">
          Find your <span className="serif-italic text-[#E63946]">neighborhood.</span>
        </h1>
        <p className="text-[#555] mt-6 max-w-2xl text-lg font-light">
          From the historic streets of The Heights to the leafy estates of River Oaks — explore Houston's most loved residential pockets.
        </p>
      </section>

      <section className="max-w-7xl mx-auto px-6 lg:px-10 pb-24">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {list.map((n) => (
            <Link
              key={n.id}
              to={`/neighborhoods/${n.slug}`}
              className="group bg-white border border-gray-200 rounded-xl overflow-hidden card-lift"
              data-testid={`nbhd-card-${n.slug}`}
            >
              <div className="relative aspect-[4/3] overflow-hidden bg-gray-100">
                <img src={n.image} alt={n.name} className="w-full h-full object-cover img-zoom" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
                <div className="absolute bottom-4 left-4 text-white">
                  <div className="font-display text-2xl font-semibold">{n.name}</div>
                </div>
              </div>
              <div className="p-6">
                <p className="text-sm text-[#555] leading-relaxed line-clamp-3">
                  {n.description}
                </p>
                <div className="flex items-center justify-between mt-5 pt-5 border-t border-gray-100">
                  <div>
                    <div className="text-[10px] uppercase tracking-[0.18em] text-gray-500">Median price</div>
                    <div className="font-display text-lg font-semibold text-[#1A1A1A]">
                      {formatPrice(n.median_price)}
                    </div>
                  </div>
                  <span className="text-sm font-semibold text-[#E63946] flex items-center gap-1">
                    Explore <ArrowRight className="w-4 h-4" />
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
}
